import { URL,URLsmall } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import Notification from '../../handlers/Notification';
import {
	BRANCH_ACCESS,
	BRANCH_GROUPS_ACCESS,
	COMPANY_ACCESS
} from '../../constants/general';
import { b64toBlob } from './UtilsOperation';

// var pubnub;

/* session utilities */

const setupTokenRenewal = () => {
    localStorage.setItem('expires_in', localStorage.getItem('tokenExpirationInSeconds') * 1000 + Date.now() - 600000)//240000 );
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token') || '';
    scheduleTokenRenewal();
}

let tokenRenewalTimeout;
const scheduleTokenRenewal = () => {
    const expiresIn = JSON.parse(localStorage.getItem('expires_in'));
    const delay = expiresIn - Date.now();

    if (delay > 0) { // if has expired (with an interval of 3 days -259200000-)

        tokenRenewalTimeout = setTimeout(() => {
            renewToken();
        }, delay);

    } else{
        renewToken();
    }

}

/* lang utilities */

let loadJsonLang = (code) => {
    return new Promise((resolve, reject) => {
        resolve( require('../../language/'+code+'.json') );
        //reject(Notification.show({type: "error", title:"Error al inicializar app", msg:"Error: Archivo de idiomas no encontrado." /> ) );
    })
}

const changeUserDefaultLanguage = (code) => {
    return (dispatch) => {

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return loadJsonLang(code).then(
            response => {
                localStorage.setItem('lang_code', code);
                dispatch({
                    type: "SET_USER_DEFAULT_LANGUAGE",
                    lang_code: code,
                    json_lang: response
                })
            }
        )
    }
}

/* xPENSAR: esto sale en el login pero no se si lo usa internamente coreui o se puede borrar */
const setValues = (target) => {
    return (dispatch) => {
        dispatch({
            type: 'SET_VALUES',
            target: target
        })
    }
}


/* Login related */

const logout = () => {
    return (dispatch) => {
        return axios.post( URL.replace('companies', 'logout').slice(0,-1) ).then( (res) => {
			clearTimeout(tokenRenewalTimeout);
			clearTimeout(pubnubTokenRenewalTimeout);
            localStorage.clear();
            window.location.reload();
            /* navigator.serviceWorker.getRegistrations().then(function (registrations) {  /// elimina el service worker
                registrations.forEach(function (reg) {
                    reg.unregister();
                });
            }); */
        }).catch( (err) => {
            /*
                // si me da error la petición yo debería poder cerrar sesión aunque sea en local?
                // y si perdí la conexión y no pudo llegar al endpoint del api?

                dispatch({
                    type: 'NOTIFICATION',
                    notification: err
                })
            */

			clearTimeout(tokenRenewalTimeout);
			clearTimeout(pubnubTokenRenewalTimeout);
            localStorage.clear();

        });
    }
}

const login = (data) => {
    return (dispatch,getState) => {
		const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        data.type= 'admin'
        return axios.post(URL + company.id + '/login-native', data)
            .then( async (res) => {
				if( !res.data.accesses.length ){
					// si no tiene ningun acceso asociado, le digo que busque ayuda
                    Notification.show({type: "error", title:`Su usuario no ha recibido privilegios`, msg:`Para entrar a este panel administrativo, por favor comuníquese con algún usuario administrativo que le otorgue acceso`} )
					dispatch({
						type: 'LOGIN_ERROR',
						loginError: true,
						adminWithoutAccess: true
					})
				}
				else {
					res.data.accesses = res.data.accesses.filter((a) => a.related_access);
					//const auth_host = `${URL + company.id}/socket-auth`;
					localStorage.setItem('user', JSON.stringify(res.data));
					localStorage.setItem('token', res.data.access_token.access_token);
					localStorage.setItem('userIsOnline', true);
					localStorage.setItem('tokenExpirationInSeconds', res.data.access_token.expires_in);

					let userHigherAccess = BRANCH_ACCESS; // por defecto es un branch admin, le llamaremos nivel 1
					let branchGroups = res.data.accesses.filter(e => e.access_type === "branch_group");
					let userCompany = res.data.accesses.filter(e => e.access_type === "company");

					if ( branchGroups.length > 0)
						userHigherAccess = BRANCH_GROUPS_ACCESS; // si tiene acceso de tipo group, le llamaremos nivel 2

					if ( userCompany.length > 0)
						userHigherAccess = COMPANY_ACCESS; // si tiene acceso de tipo company, le llamaremos nivel 3

					localStorage.setItem('userHigherAccess', userHigherAccess);
                    console.log("branchGroups",JSON.stringify(branchGroups.length > 0  && branchGroups[0] && branchGroups[0].related_access))

					if (userHigherAccess === BRANCH_ACCESS) {

						let userBranches = res.data.accesses.filter(e => e.access_type === "branch");

						if (userBranches.length === 1) {
							// es el unico acceso que hay, asi q en teoria es seguro tomar simplemente el primero que se consigue
							let branch = await res.data.accesses[0].related_access;
							localStorage.setItem('activeBranch', JSON.stringify(branch));

							/*
							const created_at = res.data.created_at;
							const updated_at = res.data.updated_at;

							if (created_at === updated_at) {
								window.location.href = '/settings'
							} else {
								window.location.href = '/dashboard'
							}*/
                            if(res.data.admin_type){
                                window.location.href = `/${res.data.admin_type.default_key}`;
                            }else{
                                window.location.href = '/order-management'
                            }

						} else {
							// si administras muchas listas de sucursales te muestro el listado de branchGroups y luego eliges cual branch especificamente
							dispatch({
								type: 'LOGIN',
								user: res.data,
								userHigherAccess: userHigherAccess,
								branches: userBranches
							})
						}
					}
					else if (userHigherAccess === BRANCH_GROUPS_ACCESS) {
						// si ademas de el acceso al branch tengo acceso al grupo, debo buscar cual es el access del branch
						const userBranches = res.data.accesses.filter(e => e.access_type === "branch");
						// si tengo un solo branch group y un solo branch lo logueo y ya
						if( userBranches.length === 1 && branchGroups.length === 1) {
							localStorage.setItem('activeBranchGroup', JSON.stringify(branchGroups.length && branchGroups[0] && branchGroups[0].related_access));
							localStorage.setItem('activeBranch', JSON.stringify(userBranches.length && userBranches[0] && userBranches[0].related_access));

							/*if (created_at === updated_at) {
								window.location.href = '/settings'
							} else {
								window.location.href = '/dashboard'
							}*/
                            if(res.data.admin_type){
                                window.location.href = `/${res.data.admin_type.default_key}`;
                            }else{
                                window.location.href = '/order-management'
                            }
						}
						// si tengo varios le paso la lista y que el elija
						else {
							if (branchGroups.length === 1){
								// si admdinistras muchas branchs pero en un solo branchGroup, solo te paso la lista de branches
								localStorage.setItem('activeBranchGroup', JSON.stringify(userBranches.length && userBranches[0] && branchGroups[0].related_access));

								dispatch({
									type: 'LOGIN',
									user: res.data,
									userHigherAccess: userHigherAccess,
									branches: userBranches
								})
							}
							else {
								// si administras muchas listas de sucursales te muestro el listado de branchGroups y luego eliges cual branch especificamente
								dispatch({
									type: 'LOGIN',
									user: res.data,
									userHigherAccess: userHigherAccess,
									branchGroups: branchGroups
								})/*<-------- */

								dispatch({
									type: 'LOGIN',
									user: res.data,
									userHigherAccess: userHigherAccess,
									branches: userBranches
								})
							}
						}
					}
					else if (userHigherAccess === COMPANY_ACCESS) {
						//const userBranches = res.data.accesses.filter(e => e.access_type === "branch");
                        if(res.data.admin_type){
                            window.location.href = `/${res.data.admin_type.default_key}`;
                        } else{
                            if ((res.data && res.data.admin_type && res.data.admin_type.id === 3) || (res.data && res.data.admin_type && res.data.admin_type.id === 9) || (res.data && res.data.admin_type && res.data.admin_type.id === 10)) {
                                window.location.href = '/reports';
                            }else if((res.data && res.data.session && res.data.session.account && res.data.session.account.type === 112) || (res.data && res.data.admin_type && res.data.admin_type.id === 8) || (res.data && res.data.admin_type && res.data.admin_type.id === 6) || (res.data && res.data.admin_type && res.data.admin_type.id === 7) || (res.data && res.data.admin_type && res.data.admin_type.id === 4) || (res.data && res.data.admin_type && res.data.admin_type.id === 5)){
                                window.location.href = '/order-management';
                            }else{
                                window.location.href = '/dashboard';
                            }
                        }

					}
				}
			})
			.catch((err) => {
				/*dispatch({
					type: 'LOGIN_ERROR',
					loginError: true
				})*/
                console.log('err',err)
				if(err && err.message){
					Notification.show({type: "error", title:err.title, msg:json_lang.errors[err.data && err.data.message] } )
				}else{
					Notification.show({type: "error", title:err.title, msg:json_lang.errors.token_not_provided_des} )
				}
			});
    }
}

const renewToken = () => {
    return axios.post(URL.replace('companies', 'token-refresh').slice(0,-1))
            .then( res => {
				localStorage.setItem('token', res.data && res.data.access_token);
				localStorage.setItem('tokenExpirationInSeconds', res.data.expires_in);
                setupTokenRenewal();
			})
			.catch( err => {
                console.log("renewToken",err)
                Notification.show({type: "error", title:"", msg:"Disculpe, hubo un error en el manejo de su sesión" } )
				/* Notification.show({
				  type: "error",
				  title: "Error al iniciar sesión",
				  msg: "Disculpe, hubo un error en el manejo de su sesión"
                }); */
                //if (err.data.error === "token_invalid"){
                    //localStorage.clear();
                    //window.location.reload();
                //}
				//setTimeout(() => , 5000);  // manejar su conectividad?
			});
}

const socketteInit = (company_id,callback) => {
    return axios.post(`${URL + company_id}/socket-auth`).then( async res => {
        const { session,company,userHigherAccess } = store.getState();
        let allowedChannels = []
        if ( (session && session.account_id) && ( company && company.id ) ) {
            allowedChannels = [
                `private-${ session.account_id }`
            ]
            if( userHigherAccess === COMPANY_ACCESS ){
                allowedChannels.push(...[
                    `group-${ company.id }-admins`
                ])
            }
            else if (userHigherAccess === BRANCH_GROUPS_ACCESS) {
                session.accesses.forEach(access => {
                    if(access.access_type === "branch"){
                        allowedChannels.push(`branch-${ access.access_id }-admins`);
                    }
                    else if(access.access_type === "branch_group"){
                        allowedChannels.push(`branch-group-${ access.access_id }-admins`);
                    }
                })
            }
            else if (userHigherAccess === BRANCH_ACCESS) {
                session.accesses.forEach(access => {
                    if (access.access_type === "branch") {
                        allowedChannels.push(`branch-${ access.access_id }-admins`);
                    }
                })
            }
        }

        window.socketteAuth(
            res.data.auth_key,
            res.data.uid,
            allowedChannels,
            callback,
            process.env.REACT_APP_ENV.toUpperCase() === "DEV" ||
                process.env.REACT_APP_ENV.toUpperCase() === "DEVELOP" ||
                process.env.REACT_APP_ENV.toUpperCase() === "LOCAL"
        );

    }).catch( e => console.log(e))
}

/* Pubnub notification related */

const socketInitialization = () => {
    /*let sockette = Sockette({
        isDebug: true,
        authKey: localStorage.getItem("pubnub_auth_key"),
        uid: "user1",
      });*/
	/*pubnub = new PubNubReact({
		publishKey: localStorage.getItem("pubnub_publish_key"),
		subscribeKey: localStorage.getItem("pubnub_subscribe_key"),
		authKey: localStorage.getItem("pubnub_auth_key")
	});
	schedulePubnubTokenRenewal();

	return pubnub;
    //return sockette;*/
}

const setupPubnubTokenRenewal = company_id => {
	// TODO: si se modifica aqui, haz cambios tambien dentro de la funcion login.. en algunos casos el llamado anidado se salta el guardado de los tokens,
	// pero la de login no requiere el llamado de la funcion schedulePubnubTokenRenewal, xq al recargar la ventana
	// necesita reiniciar el contador de peticion de token
	return axios.post(`${URL + company_id}/socket-auth`)
				.then( async res => {
                    console.log("setupPubnubTokenRenewal ---->",setupPubnubTokenRenewal)
					localStorage.setItem("pubnub_auth_key", res.data.auth_key);
					localStorage.setItem("pubnub_publish_key", res.data.publishKey);
					localStorage.setItem("pubnub_subscribe_key", res.data.subscribeKey);
					localStorage.setItem("pubnub_expires_in", res.data.expires_in * 1000 + Date.now() - 60000); // un minuto antes de que expire el token
					await schedulePubnubTokenRenewal();
				})
				.catch( e => console.log(e))
}

let pubnubTokenRenewalTimeout;
const schedulePubnubTokenRenewal = () => {
	/*const expiresIn = JSON.parse(localStorage.getItem('pubnub_expires_in'));
	const delay = expiresIn - Date.now();
	const companyId = localStorage.getItem('companyId');*/
}

/* User related */

const fetchUsers = () => {
    return (dispatch) => {
        return axios.get(URL + store.getState().company.id + '/admins')
        .then( (res) => {
            dispatch({
                type: 'FETCH_USERS',
                users: res.data.data
            })

        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});
            else
                Notification.show({type: "error", title: err.title, msg: store.getState().json_lang.custom_errors.retrieving_user_list });
        });
    }
}

const fetchUser = (id) => {
    return (dispatch) => {
        return axios.get(URL + '/users/' + id).then( (res) => {
            dispatch({
                type: 'FETCH_USER',
                user: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});
            else
                Notification.show({type: "error", title: err.title, msg: store.getState().json_lang.custom_errors.retrieving_user_data });
        });
    }
}

const fetchUserApps = (id) => {
    return (dispatch) => {

        return axios.get(URL + '/users/' + id + '/apps').then( (res) => {
            dispatch({
                type: 'FETCH_USER_APPS',
                apps: res.data
            })
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title: err.title, msg: err.message});
        });
    }
}

const updateUser = () => {
    return (dispatch) => {
        return axios.put(URL + '/users/' + store.getState().user.id, store.getState().user).then( (res) => {
            dispatch({
                type: 'FETCH_USER',
                user: res.data.user
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});
            else
                Notification.show({type: "error", title: err.title, msg: store.getState().json_lang.custom_errors.user_update_failed });
        });
    }
}

///////////////////////////////////////////////////////////////////////////////


const find = (id,token) => {
    return (dispatch) => {
        return axios.get( URLsmall+'accounts/' +id +'?token=' +token).then( (res) => {
            var newdata = {}
            if(res.data.admin){
                newdata={
                    admin:true,
                    name:res.data.admin.name,
                    display_name:res.data.admin.display_name,
                    email:res.data.admin.email,
                    avatar_url:res.data.admin.avatar_url,
                    phone:res.data.admin.phone,
                    password:"",
                    password_confirm:"",
                    token:token,
                    company_id:res.data.company_id,
                    type_name:res.data.type_name
                }
            }else if(res.data.provider){
                newdata={
                    provider:true,
                    is_deliverer: res.data.provider.is_deliverer,
                    is_shopper: res.data.provider.is_shopper,
                    name:res.data.provider.name,
                    display_name:res.data.provider.display_name,
                    email:res.data.provider.email,
                    avatar_url:res.data.provider.avatar_url,
                    phone:res.data.provider.phone,
                    password:"",
                    password_confirm:"",
                    token:token,
                    company_id:res.data.company_id,
                    type_name:res.data.type_name
                }

            }else if(res.data.client){
                newdata={
                    client:true,
                    name:res.data.client.name,
                    display_name:res.data.client.display_name,
                    email:res.data.client.email,
                    avatar_url:res.data.client.avatar_url,
                    phone:res.data.client.phone,
                    token:token,
                    company_id:res.data.company_id,
                    type_name:res.data.type_name
                }
            }
            dispatch({
                type: 'FETCH_ACCOUNT',
                account:newdata
            })
        }).catch((err) => {
            Notification.show({ type: "warning", title:`Token invalido`, msg: 'Favor solicitar reenviar uno nuevo por correo',autoC: false,config:{autoClose: false} });
            /*if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});
            else{
                error.message="Email usado o confirmado"
                Notification.show({type: "error", title: err.title, msg: store.getState().json_lang.custom_errors.retrieving_user_data });
            }*/
        });
    }
}

const toggleData = (value,type) => {

    return (dispatch) => {
        var data = {
            ...store.getState().account,
        }
        data[value.name] = value.data;
        dispatch({
            type: 'FETCH_ACCOUNT',
            account: data
        })
    }
}

const toggleOnlineStatusApiCall = (status) => {
    let status_url = status ? "/set-online" : "/set-offline";

    axios.patch( URL + store.getState().company.id + "/admins/" + store.getState().session.id + status_url )
    .then( (res) => {
        localStorage.setItem('userIsOnline', status);

        store.dispatch({
            type: "STATUS_ONLINE",
            userIsOnline: status
        })
    })
    .catch((err) => {
       console.log("error")
    })
}

const confirmRegister = (data) => {
    return (dispatch ,getState) => {
		const { dropzoneFiles/*, company*/ } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"});
		if (data.password !== data.password_confirm && data.password.length > 5 && data.password_confirm.length > 5) {

            Notification.show({type: "error", title:"", msg:"Las contraseñas deben coincidir y poseer al menos 5 caracteres"});
        }else{
            var account = new FormData();
            account.append('display_name', data.display_name)
            account.append('email', data.email)
            account.append('name', data.name)
            account.append('phone', data.phone)
            account.append('password',data.password)
            account.append('token',data.token)

            if(dropzoneFiles.length){
                var block = dropzoneFiles.split(";");
                var contentType = block[0].split(":")[1];
                var realData = block[1].split(",")[1];
                var blob = b64toBlob(realData, contentType);
                account.append('avatar', blob);
            }
            else if(data.avatar_url && data.avatar_url !== null){
                account.append('avatar_url', data.avatar_url)
            }
            if(data.provider){
                let newPayoutData = [];
                if(data.payout_accounts.bank_name){
                    newPayoutData = [{
                        bank_name: data.payout_accounts.bank_name,
                        document: `${data.payout_accounts.document_prefix}${data.payout_accounts.document}`,
                        account: data.payout_accounts.account,
                        name: data.payout_accounts.name,
                        email: data.payout_accounts.email || '',
                        type: "national_bank_account"
                    }]
                } else if(data.payout_accounts.bank_code){
                    newPayoutData = [{
                        bank_code: data.payout_accounts.bank_code,
                        document: `${data.payout_accounts.document_prefix}${data.payout_accounts.document}`,
                        phone: `${data.payout_accounts.phone_prefix}${data.payout_accounts.phone}`,
                        type: "mobile_payment"
                    }]
                }
                account = {
                    display_name: data.display_name,
                    email: data.email,
                    name: data.name,
                    phone: data.phone,
                    password: data.password,
                    token: data.token,
                    payload: {
                        data: {
                            brand: data.brand,
                            model: data.model,
                            color: data.color,
                            plate: data.plate,
                            year: data.year
                        },
                        service_type: Number(data.service_type),
                        vehicle_type: Number(data.vehicle_type),
                        payout_accounts: newPayoutData
                    }
                };

            }
            return axios.post(`${URLsmall}confirm/${data.company_id}?type=${data.type_name}`, account).then( (res) => {
                dispatch({
                    type: 'REGISTER',
                    user: res.data.user
                })
                if(data.provider===true){
                   window.location.href = '/confirmed'
                }else if(data.client===true){
                   window.location.href = '/confirmed-client'
                }else{
                   //window.location.href = '/confirmed-client'
                   window.location.href = window.location.origin;
                }
            }).catch((err) => {
                dispatch({type: "REMOVE_LOADING"});
                if(err.message)
                    Notification.show({type: "error", title: err.title, msg: err.message});
            });
        }
    }
}

const invalidateRegister = (data) => {
    data = {
        email:data.email,
        token:data.token
    }
    return (dispatch) => {
        return axios.post(URLsmall + 'invalidate/' + store.getState().company.id  , data).then( (res) => {
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title: err.title, msg: err.message});
        });
    }
}

const validateRegister = (data) => {
    var newdata = {
        email:data.email,
        token:data.token
    }
    return (dispatch) => {
        return axios.post(`${URLsmall}validate/${data.company_id}?type=client`, newdata).then( (res) => {
            window.location.href = '/confirmed-client'
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title: err.title, msg: err.message});
        });
    }
}

const forgotPasword = (email, type, showNotification = true) => {
    return (dispatch,getState) => {
        return axios.post(`${URL+getState().company.id}/forgot-password/${email}?type=${type}`).then( (res) => {
            var succesful = getState().json_lang.common.success
            if (showNotification)
                Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.email_sent});
            dispatch({
                type: 'UPDATE_PROVIDER_SUCCESS',
                providers: getState().providers,
                provider: getState().provider,
                preloader: false
            })
        }).catch((err) => {
            /*if(err.message)*/
                Notification.show({type: "error", title: err.title, msg:"El e-mail no fue encontrado"});
        });
    }
}

const recoverPasword  = (type) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        var account={
            email:getState().account.email,
            password:getState().account.password,
            token:getState().account.token
        };
        return axios.post(`${URLsmall}recover/${getState().account.company_id}?type=${type}`,account).then( (res) => {
            window.location.href = '/confirmed-client'
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err.title, msg: err.message});
            else
                Notification.show({type: "error", title: err.title, msg: "No se pudo procesar correctamente su solicitud"});
        });
    }
}

const getAccount = (id) => {
    return (dispatch,getState) => {
    	const { company, json_lang } = getState();
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL+company.id}/accounts/${id}`).then( (res) => {
            dispatch({
                type: 'FETCH_ACCOUNT',
                account:res.data
            })
        }).catch((err) => {
            Notification.show({
                type: "error",
                title: err.title,
                msg: err.message && err.message !== 'generic'? err.message : json_lang.custom_errors.user_restore_failed
            });
        });
    }
}

const getAccounts = (query) => {
    return (dispatch,getState) => {
    	const { company, json_lang, session } = getState();
        return axios.get(`${URL+company.id}/accounts?search=${query}`).then((res) => {
            const filteredData = res.data.data.filter(user => user.id !== session.account_id);
            dispatch({
                type: 'FETCH_ACCOUNTS',
                accounts: {
                    ...res.data,
                    data: [ ...filteredData ]
                }
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title: err.title,
                msg: err.message && err.message !== 'generic'? err.message : json_lang.custom_errors.user_restore_failed
            });
        });
    }
}

export {
	getAccount,
    getAccounts,
    login,
    setValues,
    socketInitialization,
    toggleOnlineStatusApiCall,
    changeUserDefaultLanguage,
    confirmRegister,
    validateRegister,
    invalidateRegister,
    logout,
    scheduleTokenRenewal,
    setupTokenRenewal,
    fetchUser,
    fetchUsers,
	fetchUserApps,
    toggleData,
    updateUser,
    find,
    forgotPasword,
    recoverPasword,
    socketteInit
};



// WEBPACK FOOTER //
// ./src/store/actions/userActions.js